import { InvestmentDetailsInterface } from "../../../../models";
import {
  DealSpecificData as SharedDealSpecificData,
  mapInvestmentsToDealSpecificData as mapInvestmentsToDealSpecificDataShared,
} from "../../utils/dealSpecificDataUtils";

export type DealSpecificData = SharedDealSpecificData;

export const mapInvestmentsToDealSpecificData = (
  investments: InvestmentDetailsInterface[],
  // Temporary keys used before the resource is created
  companyDraftKey: string | undefined,
  projectKeyMap: Record<string, string>,
  landholdingDraftKeys: string[],
  // Actual keys returned by api
  companyKey: string | undefined,
  landholdingKeys: string[],
  saveData: boolean
): DealSpecificData => {
  return mapInvestmentsToDealSpecificDataShared(investments, {
    transformAssociations: (associations) => {
      const filteredAssociations = associations.filter(
        (associationUuid) =>
          associationUuid !== companyDraftKey && !landholdingDraftKeys.some((draftKey) => draftKey === associationUuid)
      );

      let persistedAssociations = filteredAssociations.map(
        (associationUuid) => projectKeyMap[associationUuid] ?? associationUuid
      );

      if (saveData && companyKey) persistedAssociations.push(companyKey);
      if (saveData && landholdingKeys) persistedAssociations = persistedAssociations.concat(landholdingKeys);

      return persistedAssociations;
    },
  });
};
